var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubbleLeftRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/chat-bubble-left-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27 11.3488C28.1787 11.728 29 12.853 29 14.145V19.8591C29 21.3746 27.8701 22.6597 26.3596 22.783C25.9077 22.8199 25.4545 22.8521 25 22.8797V27.0007L21 23.0007C19.195 23.0007 17.4075 22.9271 15.6403 22.7829C15.2426 22.7504 14.8712 22.6374 14.5399 22.4608M27 11.3488C26.7981 11.2838 26.5857 11.2407 26.3652 11.2224C24.5962 11.0756 22.8068 11.0007 21 11.0007C19.1931 11.0007 17.4037 11.0756 15.6348 11.2224C14.1267 11.3476 13 12.6317 13 14.145V19.859C13 20.9754 13.6131 21.9668 14.5399 22.4608M27 11.3488V8.85048C27 6.68859 25.4643 4.81493 23.3204 4.53661C20.5971 4.18307 17.82 4.00073 15.0004 4.00073C12.1804 4.00073 9.4031 4.18311 6.67951 4.53672C4.53564 4.81506 3 6.68871 3 8.85057V17.1509C3 19.3128 4.53564 21.1864 6.67953 21.4648C7.44881 21.5647 8.22239 21.6509 9 21.7232V28.0007L14.5399 22.4608",
    stroke: "#3B82F6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubbleLeftRight);
export default __webpack_public_path__ + "static/media/chat-bubble-left-right.d8457a8403694b33e91dba481683cbd0.svg";
export { ForwardRef as ReactComponent };